import { ConvexReactClient } from "convex/react";

export const convexUrl = import.meta.env.VITE_CONVEX_URL;

export function isValidConvexUrl(value: string | undefined): value is string {
  if (!value) {
    return false;
  }

  try {
    const url = new URL(value);
    return url.protocol === "https:" && url.hostname.endsWith(".convex.cloud");
  } catch {
    return false;
  }
}

export const convex = isValidConvexUrl(convexUrl)
  ? new ConvexReactClient(convexUrl, { unsavedChangesWarning: false })
  : null;
